import * as React from 'react';
const FeeIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={90}
    height={90}
    fill="none"
    viewBox="0 0 96 96"
    {...props}
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H92C94.2091 0 96 1.79086 96 4V92C96 94.2091 94.2091 96 92 96H4C1.79086 96 0 94.2091 0 92V4Z"
      fill="url(#FeeIcon_svg)"
    />
    <path
      d="M22 66C36.5792 66 50.7029 67.9499 64.1247 71.6033C66.0633 72.131 68 70.6895 68 68.6803V66M26 28V30C26 31.1046 25.1046 32 24 32H22M22 32V31C22 29.3431 23.3431 28 25 28H70M22 32V56M70 28V30C70 31.1046 70.8954 32 72 32H74M70 28H71C72.6569 28 74 29.3431 74 31V57C74 58.6569 72.6569 60 71 60H70M74 56H72C70.8954 56 70 56.8954 70 58V60M70 60H26M26 60H25C23.3431 60 22 58.6569 22 57V56M26 60V58C26 56.8954 25.1046 56 24 56H22M56 44C56 48.4183 52.4183 52 48 52C43.5817 52 40 48.4183 40 44C40 39.5817 43.5817 36 48 36C52.4183 36 56 39.5817 56 44ZM64 44H64.02V44.02H64V44ZM32 44H32.02V44.02H32V44Z"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="FeeIcon_svg"
        x1="48"
        y1="0"
        x2="48"
        y2="96"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F49C9C" />
        <stop offset="1" stopColor="#E05252" />
      </linearGradient>
    </defs>
  </svg>
);
export default FeeIcon;
